import { CSSProperties, ComponentPropsWithoutRef, useState } from "react";
import { Button, FormControl, Modal } from "react-bootstrap";
import { createPortal } from "react-dom";
import messages, { NAME_PLACEHOLDER } from "messages";
// types
import type { DataTransferUploadTaskState } from "components/Dashboard/DoctorDashboard/views/data-transfer/types";
// components
import ModalHeaderLayout from "components/modal/modal-header-layout/ModalHeader";
// styles
import styles from "./styles.module.scss";

type Props = {
  value: DataTransferUploadTaskState;
  // TODO: it should be the same interface from the context provider
  onSubmit: () => void;
  style: CSSProperties;
} & Pick<ComponentPropsWithoutRef<typeof ModalHeaderLayout>, "onHide">;

/**
 * renders a stateless UI for password input
 */
const PasswordEditor = ({ value, onSubmit, style, onHide }: Props) => {
  const [pwd, setPwd] = useState(value.password || "");

  return createPortal(
    <Modal.Dialog
      style={style}
      size={"lg"}
      className={styles["password-editor"]}
      contentClassName={styles["password-editor__content"]}
    >
      <ModalHeaderLayout
        className={styles["password-editor__header"]}
        Header={messages.password}
        onHide={onHide}
        showHeaderDivider={false}
      />

      <Modal.Body className={styles["password-editor__body"]}>
        <p>
          {messages.pleaseEnterThePassword.replace(
            NAME_PLACEHOLDER,
            value.name,
          )}
        </p>
        <FormControl
          type={"password"}
          onChange={(e) => setPwd(e.target.value)}
          defaultValue={value.password}
          placeholder={messages.enterPassword}
        />
      </Modal.Body>

      <Modal.Footer className={styles["password-editor__footer"]}>
        <Button
          className={styles["password-editor__action"]}
          variant="outline-primary"
          onClick={onHide}
        >
          {messages.cancel}
        </Button>
        <Button
          className={styles["password-editor__action"]}
          variant="primary"
          disabled={!pwd}
          onClick={onSubmit}
        >
          {messages.ok}
        </Button>
      </Modal.Footer>
    </Modal.Dialog>,
    document.body,
  );
};

export default PasswordEditor;
